import moment from "moment";

import { HistorySampling } from "../../services/investments/types";
import { DateFormat, formatDate } from "../../utils";

const isMonthEnd = (date: string): boolean =>
  moment(date).endOf("month").format(DateFormat.ISO) === date;

// Only a month-end point may read as a month: the opening anchor and the live point would otherwise collide with one.
export const historyXLabelsOf = (
  points: { date: string }[],
  sampling: HistorySampling | undefined,
): string[] =>
  points.map((point) =>
    formatDate(
      point.date,
      sampling === "MONTH_END" && isMonthEnd(point.date)
        ? DateFormat.MY_SHORT
        : DateFormat.DMY_SHORT,
    ),
  );
